import { render, staticRenderFns } from "./BrebLoading.vue?vue&type=template&id=f82a9b00&scoped=true&"
import script from "./BrebLoading.vue?vue&type=script&lang=js&"
export * from "./BrebLoading.vue?vue&type=script&lang=js&"
import style1 from "./BrebLoading.vue?vue&type=style&index=1&id=f82a9b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a9b00",
  null
  
)

export default component.exports